export const GOOGLE_MEET_LINK = "https://calendar.app.google/go4eTdxZEAjYRqZFA";
export const PHONE = "+1 (945) 268-1230";
export const PHONE_HREF = "tel:+19452681230";
export const EMAIL = "quote@therecoveryshops.com";
export const BRAND = "The Recovery Shops";
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_luxury-wellness-shop/artifacts/ifa7oxe3_THE%20RECOVERY%20SHOPS%20%285%29.png";
